<fd-dynamic-page>
  <fd-dynamic-page-header />
  <fd-dynamic-page-content>
    <div class="search">
      <h1 class="search-header" fd-title>How can we help you?</h1>
      @if (helpContext()?.displayName) {
        <h2 class="search-context-display-name">
          Find assistance for {{ helpContext()?.displayName }}
        </h2>
      }
      <form (submit)="goToStack()">
        <div class="search-input">
          <fd-input-group
            data-testid="dxp-help-center-search-input"
            fd-initial-focus="true"
            placeholder="Search Stack"
            [ngModelOptions]="{ standalone: true }"
            [(ngModel)]="searchInput"
          />
        </div>

        <button
          data-testid="dxp-help-center-search-button"
          fd-button
          fdType="emphasized"
          label="Search Stack"
          title="Search Stack"
          (click)="goToStack()"
        ></button>
      </form>
    </div>

    <div class="card-grid">
      @if (showBugTrackerCard()) {
        <app-help-center-card
          buttonDataTestId="dxp-help-center-bug-button"
          buttonText="Report Incident"
          data-testid="dxp-help-center-card-bug"
          glyph="email"
          subtitle="Create tickets to report a bug or issue you are facing.
            "
          title="Report Incident"
          (buttonClicked)="goToBugReporting()"
        />
      }
      @if (showFeedbackTrackerCard()) {
        <app-help-center-card
          buttonDataTestId="dxp-help-center-feedback-button"
          buttonText="Provide Feedback"
          data-testid="dxp-help-center-card-feedback"
          glyph="feedback"
          subtitle="
              Provide feedback on our product and request missing functionality.
            "
          title="Product Feedback"
          (buttonClicked)="goToFeedback()"
        />
      }
      @if (showDocumentationCard()) {
        <app-help-center-card
          buttonDataTestId="dxp-help-center-documentation-button"
          buttonText="Check Documentation"
          data-testid="dxp-help-center-card-documentation"
          glyph="documents"
          subtitle="
               Find valuable information of how to get started and use our product.
            "
          title="Documentation"
          (buttonClicked)="goToDocumentation()"
        />
      }
    </div>
  </fd-dynamic-page-content>
</fd-dynamic-page>
